import styled from 'styled-components'

import { COLOR } from '@/shared/constant/color'
import { customMedia } from '@/styles/common/common'

const NoticeWrap = styled.div`
  margin: 0 0 123px 0;
  ${customMedia.lessThan('tablet')`
    margin: 0 auto 124px auto;
`}
`

const NoticeList = styled.div<{ line: string }>`
  height: 78px;
  border-bottom: 1px solid ${COLOR.blueGray2};
  border-top: ${(props) => props.line === 'true' && `1px solid ${COLOR.blueGray2}`};
  display: flex;
  font-family: NotoSansRegular, sans-serif;
  justify-content: space-between;

  > span {
    line-height: 78px;
    color: ${COLOR.gray30};
    margin: 0 18px 0 0;
    padding-right: 30px;

    ${customMedia.lessThan('tablet_cut_line')`
     display: flex;
     justify-content: space-between;
    `}
    &:after {
      position: absolute;
      margin: 35.5px 0 35.5px 15px;
      content: '';
      width: 8px; /* 사이즈 */
      height: 8px; /* 사이즈 */
      border-top: 1px solid #a7b7ce; /* 선 두께 */
      border-right: 1px solid #a7b7ce; /* 선 두께 */
      transform: rotate(45deg); /* 각도 */
      ${customMedia.lessThan('tablet_cut_line')`
         right: 31px;
    `}
    }
  }

  > a {
    display: inline-block;
    width: 75%;
    white-space: pre-line;
    font-family: NotoSansBold, sans-serif;
    cursor: pointer;
    font-size: 16px;
    line-height: 78px;
    margin: 0 0 0 20px;
  }

  ${customMedia.lessThan('tablet')`
    min-height: 68px;
    flex-direction: column;
    justify-content: center;
    > span {
      line-height: 20px;
      margin: 0 0 0 16px;
      font-size: 12px;
         &:after {
          position: absolute;
          margin: -2.5px 0 0 500px;
    }
    }
    > a { 
     line-height: 17px;
     font-size: 14px;
     margin: 0 0 0 16px;
  }
`}
`

const NoticeDetailWrap = styled.div`
  display: block;
  text-align: center;
  margin: 0 0 75px 0;
  ${customMedia.lessThan('tablet')`
    margin: 0 0 249px 0;
`}
`
const NoticeDetailContents = styled.div`
  border-bottom: 1px solid ${COLOR.blueGray2};
  border-top: 1px solid ${COLOR.blueGray2};

  > h3 {
    font-size: 18px;
    line-height: 26px;
    font-family: NotoSansBold, sans-serif;
    margin: 40px auto 6px auto;
    white-space: pre-line;
  }

  > span {
    font-family: NotoSansRegular, sans-serif;
    font-size: 16px;
    line-height: 23px;
    color: ${COLOR.blueGray5};
  }

  > pre {
    font-family: NotoSansRegular, sans-serif;
    text-align: left;
    margin: 60px auto;
    width: 600px;
    font-size: 14px;
    white-space: pre-wrap;
  }

  > div {
    width: 95%;
    max-width: 600px;
    font-family: NotoSansRegular, sans-serif;
    text-align: left;
    margin: 60px auto;
    font-size: 14px;
    overflow-wrap: break-word;
    white-space: break-spaces;
  }

  ${customMedia.lessThan('tablet')`
    margin: 0 0 36px 0;
    >span {
      font-size: 12px;
      line-height: 17px;
    }
    >pre{
      min-width: 328px;
      max-width: 568px;
      width: 95%;
      margin: 46px auto 24px auto;
    }
    > div {
    margin: 46px auto 24px auto;
    }
`}
`

export { NoticeDetailContents, NoticeDetailWrap, NoticeList, NoticeWrap }
